import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ClassAttendanceExcuseInsertRequest } from "./ClassAttendanceExcuseInsertRequest";
import { StringRequest } from "./StringRequest";
import { ClassAttendanceExcuseUpdateRequest } from "./ClassAttendanceExcuseUpdateRequest";

@Injectable()
export class DataService_ClassAttendanceExcuseSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadExcuse(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadAttendanceExcuse?" + "SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseInsert(parms: ClassAttendanceExcuseInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ClassAttendanceExcuseInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseCodeInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ClassAttendanceExcuseCodeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseDescInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ClassAttendanceExcuseDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseUpdate(parms: ClassAttendanceExcuseUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ClassAttendanceExcuseUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseDelete(ClassAttendanceExcuseID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ClassAttendanceExcuseDelete?ClassAttendanceExcuseID=" + ClassAttendanceExcuseID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseToggle(ClassAttendanceExcuseID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ClassAttendanceExcuseToggle?ClassAttendanceExcuseID=" + ClassAttendanceExcuseID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
